import { Component, OnDestroy, OnInit } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import {
  faRefresh,
} from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'refresh-button',
  templateUrl: './refresh-button.component.html',
  styleUrls: ['./refresh-button.component.css'],
  standalone: true,
  imports: [
    FontAwesomeModule,
  ],
})
export class RefreshButton {
  refreshIcon = faRefresh;
}
